import React from "react";
import { Link } from "react-router-dom";

const DetailsRow = ({ days }) => {
  const RowElement = (job, idx) => {
    const {
      job_no, job_id, job_service_id, registered_surveyor_name, job_title, type, start_date, finish_date, worked_time
    } = job;

    const jobTitleCell = job_id && job_service_id ? (
      <Link to={`/jobs/${job_id}/job_services/${job_service_id}`} target="_blank" rel="noopener noreferrer" className="link-no-decoration">
        {job_title || "—"}
      </Link>
    ) : (
      job_title || "—"
    );

    return (
      <tr key={`${registered_surveyor_name}-${job_no}-${idx}`}>
        <td>{job_no}</td>
        <td>{jobTitleCell}</td>
        <td>{type}</td>
        <td>{start_date}</td>
        <td>{finish_date}</td>
        <td>{worked_time != null ? `${worked_time} Hrs` : "—"}</td>
      </tr>
    );
  };

  return (
    <>
      {days.map((day, dayIdx) => {
        const { jobs, total } = day;
        return (
          <React.Fragment key={dayIdx}>
            {jobs.map((job, idx) => RowElement(job, idx))}
            {total && (
              <tr className="font-weight-bold text-white" style={{ backgroundColor: "#6c757d" }}>
                <td>Total</td>
                <td colSpan={3} />
                <td>{total.jobsComplete} Jobs</td>
                <td>{total.totalWorkedTime != null ? `${total.totalWorkedTime} Hrs` : "—"}</td>
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default DetailsRow;
